module.exports = __webpack_public_path__ + "images/emoji/full_moon.39bc707b27905956ca95.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/full_moon.png
// module id = qeFI
// module chunks = 13